export default function StepEmailVerification({ email, error }) {
  return (
    <div style={{ marginTop: 20 }}>
      <p>
        Enviamos um e-mail da <strong>AWS</strong> para{" "}
        <strong>{email}</strong>.
        <br />
        Clique no link de verificação para concluir a integração.
      </p>

      {error && (
        <p style={{ color: "red", marginTop: 12 }}>
          {error}
        </p>
      )}
    </div>
  );
}